import request from '@/utils/server'

// 获取小程序在售菜品
export function getCommodityLis(query) {
    return request({
      url: '/commodity/getCommodityList',
      method: 'get',
      params: query
    })
  }